
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SharedDataService {

  private dataSource = new BehaviorSubject<any>(null);
  data$: Observable<any> = this.dataSource.asObservable();

  setData(data: any): void {
    this.dataSource.next(data);
  }

  getData(): Observable<any> {
    return this.data$;
  }

  clearData(): void {
    this.dataSource.next(null);
  }
  
}
